import dateToLocalisedString from "@utils/date/dateToLocalisedString";

/**
 *  現在の日付のDateオブジェクトを文字列に整形する
 */
export const dateTodayForApi = (): string =>
  dateToLocalisedString(new Date(), "YYYYMMDD");
